// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".warning-bubble[data-v-0389f50b]{padding:10px 12px 11px 12px;border-radius:10px;border:1px solid #dcdccf;background-color:#fffef8;p[data-v-0389f50b]{font-size:14px}}", ""]);
// Exports
module.exports = exports;
